<template>
  <div class="grid">
    <v-form ref="form" lazy-validation v-on:submit.prevent>
      <div class="grid-title">
        <h4>{{ $t("ROOM_INFOMATION") }}</h4>
      </div>
      <v-spacer />
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-row class="mt-0">
          <v-col sm="12" class="pt-0">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("NAME_ROOM_TYPE") }} *</label>
                    <v-text-field v-model="roomData.defaultName" outlined dense :rules="ruleName" counter maxlength="250"
                      class="input-counter" v-on:keyup="updateRoomTitle(roomData.defaultName)"></v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="6" v-model="roomData.defaultDesc" outlined dense counter="3000" maxlength="3000"
                      :rules="ruleDescNotRequired" class="input-counter"
                      v-on:keyup="updateRoomDescription(roomData.defaultDesc)"></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-for="code in codeLangs" :key="code">
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("NAME_ROOM_TYPE") }} *</label>
                    <v-text-field v-model="roomData.i18ns.find(x => x.lang == code).name" outlined dense counter
                      maxlength="250" class="input-counter" :rules="ruleName"></v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="6" v-model="roomData.i18ns.find(x => x.lang == code).description
                      " outlined dense counter="3000" maxlength="3000" class="input-counter"
                      :rules="ruleDescNotRequired"></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
        <v-divider />
        <label class="label-title">{{ $t("ROOM_TYPE_SETTING") }}</label>
        <p class="mb-0 mt-2" v-if="roomData.chainCode">{{ $t('CHAIN_CODE') }}: {{ roomData.chainCode }}</p>
        <v-row>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_CODE") }} *</label>
            <v-text-field v-model="roomData.roomCode" v-on:keyup="validateRoomCode(roomData.roomCode)"
              :disabled="isDisableRoomCode" :rules="ruleCode" :error="isDuplicateRoomCode" outlined dense counter
              maxlength="20" class="input-counter code">
            </v-text-field>
            <small v-if="isDuplicateRoomCode" class="invalid-text">{{
              $t("_ROOM_SALE.ROOM_TYPE.ERROR_ROOM_CODE")
            }}</small>
          </v-col>

          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}</label>
            <v-select item-text="text" item-value="value" :items="select.roomGroup" v-model="roomData.roomGroup" outlined
              dense>
            </v-select>
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_PARENT_TYPE") }}</label>
            <v-select item-text="text" item-value="value" :items="select.roomParent" v-model="roomData.parentId"
              :error="isInvalidRoomParent" outlined dense clearable @change="validateRoomParent(roomData.parentId)">
            </v-select>
            <small v-if="isInvalidRoomParent" class="invalid-text">{{
              $t("_ROOM_SALE.ROOM_TYPE.ERROR_ROOM_PARENT")
            }}</small>
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_SALE_PACKAGE.ROOM_CATEGORY") }}</label>
            <v-select item-text="text" item-value="value" :items="roomCategorys" v-model="roomData.roomCategoryId"
              outlined dense clearable>
            </v-select>
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.MAX_PERSON") }} *</label>
            <vuetify-number v-model="roomData.maxGuest" :options="numberOption" dense
              :rules="[rules.required, rules.number]" outlined />
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.MAX_ADULT") }} *</label>
            <vuetify-number v-model="roomData.maxAdults" :options="numberOption" dense
              :rules="[rules.required, rules.numberAdult]" outlined />
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.MAX_CHILD") }} *</label>
            <vuetify-number v-model="roomData.maxChildren" :options="numberOption" dense
              :rules="[rules.required, rules.number]" outlined />
          </v-col>
          <v-col sm="3">
            <label>{{ $t("_ROOM_SALE.ROOM_TYPE.MAX_KID") }} *</label>
            <vuetify-number v-model="roomData.maxBaby" :options="numberOption" dense
              :rules="[rules.required, rules.number]" outlined />
          </v-col>
          <v-col sm="3">
            <label>{{ $t("TOTAL_ROOM") }} *</label>
            <v-text-field type="number" v-model="roomData.totalRooms" :rules="roomData.parentId ? '' : [ruleNumber]"
              outlined dense :disabled="roomData.parentId || !isPermission">
            </v-text-field>
          </v-col>
          <v-col sm="3">
            <label>{{ $t("ROOM_DIMENSION") }} (m2) *</label>
            <v-text-field type="number" v-model="roomData.roomSize" :rules="[ruleNumber]" outlined dense>
            </v-text-field>
          </v-col>
          <v-col sm="3">
            <label>{{ $t("PRICE_NORMAL_DAY") }} ({{ usedCurrency }}) *</label>
            <v-text-field v-model="defaultPrice"
              ref="defaultPrice"
              @keydown="keyCurrencyDown($event, usedCurrency)"
              :options="usedCurrency == 'VND' ? amountOptionsVi : amountOptionsEn" dense
              :rules="[ruleMoney.empty, ruleMoney.number]" 
              :key="`defaultPrice_${forceRenderKey}`" 
              outlined
              :error="priceErrors && !!priceErrors['defaultPrice']"
              :error-messages="priceErrors['defaultPrice'] || ''"
              class="price-errors"
            />
          </v-col>
          <v-col sm="3">
            <label>{{ $t("PRICE_WEEKEND") }} ({{ usedCurrency }}) *</label>
            <v-text-field v-model="weekendRate"
              ref="weekendRate"
              @keydown="keyCurrencyDown($event, usedCurrency)"
              :options="usedCurrency == 'VND' ? amountOptionsVi : amountOptionsEn" dense
              :rules="[ruleMoney.empty, ruleMoney.number]" :key="`weekendRate_${forceRenderKeyRate}`" 
              outlined
              :error="priceErrors && !!priceErrors['weekendRate']"
              :error-messages="priceErrors['weekendRate'] || ''"
              class="price-errors"
            />
          </v-col>
          <v-col sm="3">
            <v-checkbox 
              color="indigo darken-3" 
              :label="$t('FREE_SALE_ALLOTMENT')" 
              :value="roomData.sellAllotment" 
              v-model="roomData.sellAllotment"
            ></v-checkbox>
          </v-col>
          <v-col sm="3">
            <v-checkbox color="indigo darken-3" :label="$t('ACTIVE')"
              :value="roomData.status" v-model="roomData.status"></v-checkbox>
          </v-col>
        </v-row>
        <v-divider />
        <div class="d-flex">
          <label class="label-title">{{ $t("SAFE_PRICE_RANGE.PROTECTION_RATE") }}</label>
          <v-tooltip top nudge-right="170" content-class="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <i class="icon-info fs-18 text-primary ml-1" v-bind="attrs" v-on="on"></i>
            </template>
            <span>{{ $t('SAFE_PRICE_RANGE.PROTECTION_RATE_TOOLTIP') }}</span>
          </v-tooltip>
        </div>
        <v-row>
          <v-col sm="6">
            <label>{{ $t("SAFE_PRICE_RANGE.MINIMUM_RATE") }}</label>
            <v-text-field 
              v-model="minimumRateComputed"
              @keydown="keyCurrencyDown($event, usedCurrency)"
              dense
              outlined 
              :prefix="prefixCurrency"
              :suffix="suffixCurrency"
              :rules="priceMinRules"
              ref="priceMin"
            />
          </v-col>
          <v-col sm="6">
            <label>{{ $t("SAFE_PRICE_RANGE.MAXIMUM_RATE") }}</label>
            <v-text-field 
              v-model="maximumRateComputed"
              @keydown="keyCurrencyDown($event, usedCurrency)"
              dense
              outlined 
              :prefix="prefixCurrency"
              :suffix="suffixCurrency"
              :rules="priceMaxRules"
              ref="priceMax"
            />
          </v-col>
        </v-row>
        <v-divider />
        <label class="label-title">{{ $t("BED_TYPE_SETTING") }}</label>
        <v-expansion-panels multiple class="group-bed">
          <v-row>
            <v-col sm="6" v-for="(option, i) in listOtpsBed" :key="option.id">
              <v-expansion-panel>
                <v-expansion-panel-header v-slot="{ open }">
                  <div>
                    <v-row no-gutters class="w-100">
                      <v-col sm="12">
                        {{
                          option.id == 1
                          ? $t("COMMON_BED_TYPE")
                          : $t("COMBINATION_BED_TYPE")
                        }}
                        <br />
                        <div class="fs-10 bed-des pt-3">
                          {{ getOptionLabel(option.beds) }}
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-if="option.beds.length">
                    <v-row>
                      <v-col sm="12" v-for="(bed, i) in option.beds" :key="i">
                        <v-row>
                          <v-col sm="8" class="py-0">
                            <v-select solo item-text="value" item-value="id"
                              :items="filterListOfBeds(option.id, bed.typeId)" v-model="bed.typeId">
                            </v-select>
                          </v-col>
                          <v-col sm="3" class="py-0">
                            <v-select solo :items="select.bedQuantity" v-model="bed.quantity">
                            </v-select>
                          </v-col>
                          <v-col sm="1" class="d-flex align-center p-0" v-if="option.beds.length > 1 || option.id > 1">
                            <v-icon color="error" @click="option.beds.splice(i, 1)">delete</v-icon>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <div>
                      <v-btn color="primary" class="pl-10 mr-2">
                        <v-icon color="white" @click="addBedType(option.id)">add</v-icon>
                        <label class="has-action" @click="addBedType(option.id)">{{ $t("ADD_TYPE_BED") }}</label>
                      </v-btn>
                      <v-btn v-if="option.id > 1" @click="listOtpsBed.splice(i, 1)" depressed>{{ $t("REMOVE_OPTIONS")
                      }}</v-btn>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-col>
          </v-row>
        </v-expansion-panels>
        <v-btn @click="addBedOption" depressed><v-icon @click="addBedType(option.id)">add</v-icon>
          {{ $t("MORE_OPTIONS") }}</v-btn>
        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
          <v-btn color="primary" class="pl-10 pr-10" @click="save()" :loading="loading">{{
            $t("SAVE")
          }}</v-btn>
        </div>
      </div>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>{{
            $t("MORE_OPTIONS")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col sm="6" class="py-2">
                <label class="label-input">{{ $t("COUNTRY") }}</label>
                <v-autocomplete v-model="country" :items="select.countries" outlined dense item-text="value" item-value="id"
                  label=""></v-autocomplete>
              </v-col>
              <v-col sm="6" class="py-2">
                <label class="label-input">{{ $t("CITY") }}</label>
                <v-autocomplete v-model="city" :items="select.cities" outlined dense item-text="value" item-value="id"
                  label="" ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6" class="py-2 mb-4">
                <label class="label-input">{{ $t("DISTRICT") }}</label>
                <v-autocomplete v-model="district" :items="select.districts" outlined dense item-text="value" item-value="id"
                  label="" ></v-autocomplete>
              </v-col>
              <v-col sm="3" class="py-2 mb-4">
                <label class="label-input">{{ $t("LATITUDE") }}</label>
                <v-text-field v-model="roomData.lat" outlined dense type="number"></v-text-field>
              </v-col>
              <v-col sm="3" class="py-2 mb-4">
                <label class="label-input">{{ $t("LONGITUDE") }}</label>
                <v-text-field v-model="roomData.lng" outlined dense type="number"></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div>
              <label class="label-title">{{ $t("ROOM_DIRECTION") }}</label>
              <v-row>
                <v-col lg="3" md="4" sm="6" v-for="view in listViews" :key="view.id">
                  <v-checkbox color="indigo darken-3" :label="view.lookupItemI18n.find(x => x.lang == defaultI18n).name
                    " :value="view.id" v-model="roomData.viewIds" class="m-0 p-0"></v-checkbox>
                </v-col>
              </v-row>

              <v-divider />
              <label class="label-title">{{
                $t("_ROOM_SALE.SELL_MARKET")
              }}</label>
              <v-row>
                <v-col>
                  <v-radio-group v-model="applyAllMarket" class="mt-0">
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_ALL')" :value="'ALL'"
                      @change="applyAllMarketStatus()"></v-radio>
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_SPEC')" :value="'NOT_ALL'"
                      @change="applyAllMarketStatus()"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="listOfMarkets && applyAllMarket !== 'ALL'">
                <v-col md="3" class="child-no-margin py-0">
                  <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllMarket()"
                    v-model="selectAllMarket" />
                </v-col>
                <v-col md="3" class="child-no-margin py-0" v-for="market in listOfMarkets" :key="market.id">
                  <v-checkbox color="indigo darken-3" :label="market.value" :value="market.id" v-model="roomData.markets"
                    @change="
                      roomData.markets.length == listOfMarkets.length
                        ? (selectAllMarket = true)
                        : (selectAllMarket = false)
                      " />
                </v-col>
              </v-row>

              <v-divider />
              <label class="label-title">{{
                $t("_ROOM_SALE.SELL_CHANNEL")
              }}</label>
              <v-row>
                <v-col>
                  <v-radio-group v-model="applyAllChannel" class="mt-0">
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_ALL')" :value="'ALL'"
                      @change="applyAllChannelStatus()"></v-radio>
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_SPEC')" :value="'NOT_ALL'"
                      @change="applyAllChannelStatus()"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="listOfChannels && applyAllChannel !== 'ALL'">
                <v-col md="3" class="child-no-margin py-0">
                  <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllChannel"
                    v-model="selectAllChannel" />
                </v-col>
                <v-col md="3" class="child-no-margin py-0" v-for="channel in listOfChannels" :key="channel.id">
                  <v-checkbox color="indigo darken-3" :label="channel.value" :value="channel.id"
                    v-model="roomData.channels" @change="
                      roomData.channels.length == listOfChannels.length
                        ? (selectAllChannel = true)
                        : (selectAllChannel = false)
                      " />
                </v-col>
              </v-row>
              <div class="btn-bottom">
                <v-btn depressed class="mr-5" @click="back">{{
                  $t("BACK")
                }}</v-btn>
                <v-btn color="primary" class="pl-10 pr-10" @click="save()" :loading="loading">{{
                  $t("SAVE")
                }}</v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
    <room-update-dialog ref="showDialogModal" />
  </div>
</template>
<style lang="scss" scoped>
.custom-tooltip {
  max-width: 350px !important;
  line-height: 1.5 !important;
}
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}
</style>
<script>
import store from "@/plugins/store";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";

import { _alert } from "@/_helpers/function.js";
import { categoryService } from "@/_services/RoomInfomation/category.service.js";
import { systemService } from "@/_services/system-data.service.js";
import RoomUpdateDialog from "../../Utils/RoomUpdateDialog.vue";

import {
  MAX_CHILD_QUANTITY,
  MAX_ADULTS_QUANTITY,
  EXTRA_BED_QUANTITY,
  BED_QUANTITY,
  ROOM_INFO_ERROR
} from "@/_helpers/config.js";

export default {
  components: {'room-update-dialog': RoomUpdateDialog},
  props: {
    nextTab: Function
  },
  created() {
    this.codeLangs.forEach(e => {
      this.roomData.i18ns.push({
        lang: e,
        name: "",
        description: ""
      })
    });

    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      locations: [],
      country: null,
      city: null,
      district: null,
      ward: null,
      rulesMap: {
        required: value => !!value || this.$t('DATA_INPUT_INVALID'),
        lng: value => (value <= 180 && value >= -180) || this.$t('DATA_INPUT_INVALID'),
        lat: value => (value <= 90 && value >= -90) || this.$t('DATA_INPUT_INVALID'),
        regex: value => {
          const pattern = this.REGEX_DISTANCE
          return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
        },
      },
      panel: [0],
      amountOptionsVi: {
        locale: "vi",
        length: 9,
        precision: 0
      },
      amountOptionsEn: {
        locale: "vi",
        length: 9,
        precision: 2
      },
      numberOption: {
        locale: "vi",
        length: 2,
        precision: 0
      },
      rules: {
        required: value => !!value || this.$t("_REGISTER.REQUIRED_FIELD"),
        number: value =>
          parseFloat(value) >= 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0"),
        numberAdult: value =>
          parseFloat(value) > 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0"),
        select: value => value != null || this.$t("_REGISTER.REQUIRED_FIELD")
      },

      // priceOptions: {
      //   locale: "vi",
      //   length: 9,
      //   precision: 0
      // },
      roomData: {
        markets: null,
        defaultPrice: null,
        weekendRate: null,
        maxAdults: 1,
        maxChildren: 0,
        totalRooms: null,
        roomSize: null,
        numberOfExtraBeds: 0,
        status: true,
        i18ns: [],
        operationBedTypes: [
          // {
          //   typeId: 1,
          //   operation: 0,
          //   quantity: 1
          // }
        ],
        viewIds: [],
        sellAllotment: false,
        roomGroup: null,
        roomCategoryId: null,
        countryId: null,
        cityId: null,
        locId: null,
        areaId: null,
        lng: null,
        lng: null,
        priceMin: null,
        priceMax: null,
      },
      langSystem: this.$i18n.locale,
      langTab: "vi",
      tab: null,
      data: {},
      listViews: [],
      listOtpsBed: [],
      select: {
        child: Array.from(Array(MAX_CHILD_QUANTITY).keys()),
        adult: Array.from(Array(MAX_ADULTS_QUANTITY).keys()).map(x => ++x),
        extraBed: Array.from(Array(EXTRA_BED_QUANTITY).keys()),
        bedQuantity: Array.from(Array(BED_QUANTITY).keys()).map(x => ++x),
        bedTypes: [],
        roomParent: [],
        roomGroup: [],
        hotelTypes: [],
        stars: [],
        countries: [],
        cities: [],
        districts: [],
        wards: []
      },
      errors: ROOM_INFO_ERROR,
      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      tempTitle: "",
      tempDescription: "",
      operationBedTypes: [],
      isDuplicateRoomCode: false,
      isInvalidRoomParent: false,
      isDisableRoomCode: false,
      isEmptyDefaultTitle: false,
      ruleNotEmpty: [v => !!v || this.$t("NOT_EMPTY")],
      ruleNumber: value => parseFloat(value) > 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0"),
      ruleMoney: {
        empty: v => !!v || this.$t("NOT_EMPTY"),
        number: value => parseFloat(value) > 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0")
      },
      loading: false,
      roomCategorys: [],
      isPermission: true,
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
      timeout: null,
      forceRenderKey: 0,
      forceRenderKeyRate: 0,
      priceErrors: {}
    };
  },
  computed: {
    defaultPrice: {
      get: function () {
        return this.convertDecimalViaLocal(this.roomData.defaultPrice);
      },
      set: function (newValue) {
        clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
          const value = this.setCurrency(newValue);
          this.roomData.defaultPrice = value;
          if (value == this.roomData.defaultPrice) {
            this.forceRenderKey++;
            this.$nextTick(() => {
              if (this.$refs.defaultPrice) {
                this.$refs.defaultPrice.focus();
              }
            });
          }
        }, this.timeOutChange(newValue));
      }
    },
    weekendRate: {
      get: function () {
        return this.convertDecimalViaLocal(this.roomData.weekendRate)
      },
      set: function (newValue) {
        clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
          const value = this.setCurrency(newValue);
          this.roomData.weekendRate = value;
          if (value == this.roomData.weekendRate) {
            this.forceRenderKeyRate++;
            this.$nextTick(() => {
              if (this.$refs.weekendRate) {
                this.$refs.weekendRate.focus();
              }
            });
          }
        }, this.timeOutChange(newValue));
      }
    },
    minimumRateComputed: {
      get: function () {
        const priceMin = this.roomData.priceMin >= 0 ? this.roomData.priceMin : null;
        return priceMin != null ? this.convertDecimalViaLocal(priceMin) : null;
      },
      set: function (newValue) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const value = newValue != '' ? Number(this.setCurrency(newValue)) : null;
          this.$set(this.roomData, "priceMin", value);
          this.$nextTick(() => {
            if (this.$refs.priceMin) {
              this.$refs.priceMin.focus();
            }
          });
        }, this.timeOutChange(newValue));
      }
    },
    maximumRateComputed: {
      get: function () {
        const priceMax = this.roomData.priceMax >= 0 ? this.roomData.priceMax : null;
        return priceMax != null ? this.convertDecimalViaLocal(priceMax) : null;
      },
      set: function (newValue) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const value = newValue != '' ? Number(this.setCurrency(newValue)) : null;
          this.$set(this.roomData, "priceMax", value);
          this.$nextTick(() => {
            if (this.$refs.priceMax) {
              this.$refs.priceMax.focus();
            }
          });
        }, this.timeOutChange(newValue));
      }
    },
    priceMinRules() {
      return [
        (v) =>
          !this.roomData.priceMax ||
          this.roomData.priceMax === null ||
          this.roomData.priceMax === '' ||
          v === '' ||
          v === null ||
          parseFloat(this.setCurrency(v)) <= parseFloat(this.roomData.priceMax) ||
          this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INVALID"),
      ];
    },
    priceMaxRules() {
      return [
        (v) =>
          !this.roomData.priceMin ||
          this.roomData.priceMin === null ||
          this.roomData.priceMin === '' ||
          v === '' ||
          v === null ||
          parseFloat(this.setCurrency(v)) >= parseFloat(this.roomData.priceMin) ||
          this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INVALID"),
      ];
    },
  },
  watch: {
    tab(value) {
      this.langTab = value ? "en" : "vi";
    },
    listOtpsBed: {
      handler(value) { },
      deep: true
    },
    country(value) {
      // console.log(value)
      if (!value) {
        this.city = null;
        this.roomData.countryId = null;
        // this.select.cities = [];
        // return false;
      }
      this.roomData.countryId = value;
      this.select.cities = this.locations
        .filter(x => x.parent == value)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
    },
    city(value) {
      if (!value) {
        this.roomData.cityId = null;
        this.select.districts = [];
        this.select.wards = [];
        this.district = null;
        this.ward = null;
        return false;
      }
      this.roomData.cityId = value;

      this.select.districts = this.locations
        .filter(x => x.parent == value && x.locType == 2)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
      this.select.wards = this.locations
        .filter(x => x.locType == 3 && x.parent == value)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
    },
    district(value) {
      if (!value) {
        this.roomData.locId = null;
        return false;
      }
      this.roomData.locId = value;
    },
    ward(value) {
      if (!value) {
        this.roomData.areaId = null;
        return false;
      }
      if (!this.select.wards.find(x => x.id == value)) {
        this.roomData = null;
        return false;
      }
      this.roomData.areaId = value;
    }
  },
  methods: {
    checkValidate() {
      this.priceErrors = {};
      const { weekendRate, defaultPrice, priceMin, priceMax } = this.roomData;
      if (priceMin && priceMax && (weekendRate < priceMin || weekendRate > priceMax)) {
        this.priceErrors['weekendRate'] = this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin), priceMax: this.formatCurrencyWithSymbol(priceMax)});
      }
      if (priceMin && !priceMax && weekendRate < priceMin) {
        this.priceErrors['weekendRate'] = this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});
      }
      if (!priceMin && priceMax && weekendRate > priceMax) {
        this.priceErrors['weekendRate'] = this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)});
      }

      if (priceMin && priceMax && (defaultPrice < priceMin || defaultPrice > priceMax)) {
        this.priceErrors['defaultPrice'] = this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin), priceMax: this.formatCurrencyWithSymbol(priceMax)});
      }
      if (priceMin && !priceMax && defaultPrice < priceMin) {
        this.priceErrors['defaultPrice'] = this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});
      }
      if (!priceMin && priceMax && defaultPrice > priceMax) {
        this.priceErrors['defaultPrice'] = this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)});
      }
      return Object.keys(this.priceErrors).length == 0;
    },
    async initialize() {
      this.currency = this.priceOptionsVi.suffix;
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles
        ? currentUser.user.roles.map(role => role.fnCode)
        : undefined;
      this.isPermission = userRole.indexOf("ROOM_UPDATE_QUANTITY") >= 0
      // _resetErrorState(this.ferrors);
      let roomId = this.$route.params.id;
      if (roomId != "00000000-0000-0000-0000-000000000000") {
        service.getRoomDetail(roomId).then(res => {
          if (res.responseCode == 0) {
            this.roomData = res.data;
            if (res.data.markets == null) {
              this.applyAllMarket = "ALL";
            } else {
              this.applyAllMarket = "NOT_ALL";
            }
            if (res.data.channels == null) {
              this.applyAllChannel = "ALL";
            } else {
              this.applyAllChannel = "NOT_ALL";
            }
            if (res.data.roomCode) {
              this.isDisableRoomCode = true;
            }
          }
        });
      } else {
        this.isPermission = true
      }

      try {
        await service.getRoomView().then(res => {
          this.listViews = res.data;
        });
      } catch (err) {
        // console.log(err);
      }

      await service.getBedType().then(res => {
        this.select.bedTypes = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });

        this.select.bedTypes = this.select.bedTypes.filter(x => x.value);
      });

      await service.getRoomParentType().then(res => {
        this.select.roomParent = res.data.map(x => {
          return {
            value: x.roomId,
            text: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
        // Bỏ chính nó ra khỏi list room parent
        this.select.roomParent = this.select.roomParent.filter(
          x => x.value && x.value != roomId
        );
      });

      await service.getChannel().then(res => {
        this.listOfChannels = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfChannels = this.listOfChannels.filter(x => x.value);
      });

      await service.getMarket().then(res => {
        this.listOfMarkets = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfMarkets = this.listOfMarkets.filter(x => x.value);
      });

      await service.getRoomGroup().then(res => {
        this.select.roomGroup = res.data.map(x => {
          return {
            value: x.id,
            text: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.select.roomGroup = this.select.roomGroup.filter(x => x.value);

        // Chuyen room code sang uid do BE khi goi detail tra CODE nhung khi gui lai gui uid
        if (this.roomData.roomGroup != null) {
          this.roomData.roomGroup = res.data.find(
            x => x.lookupCode == this.roomData.roomGroup
          ).id;
        } else {
          this.roomData.roomGroup = res.data.find(
            x => x.lookupCode == "ROOM"
          ).id;
        }
      });
      await systemService.getLocations().then(res => {
        this.locations = res.data;
        this.select.countries = res.data
          .filter(x => !x.parent)
          .map(x => {
            return {
              id: x.id,
              value: x.i18ns.find(x => x.lang == this.defaultI18n)
                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                : ""
            };
          });
      });
      this.getAllRoomCategory();

      if (this.roomData.operationBedTypes.length === 0) {
        this.roomData.operationBedTypes.push({
          typeId: this.select.bedTypes[0].id,
          operation: 0,
          quantity: 1
        });
      }

      this.listOtpsBed.push({
        id: 1,
        beds: []
      });
      let currentOpt = 0;

      this.roomData.operationBedTypes.forEach((x, index) => {
        if (+x.operation === 2 && this.roomData.operationBedTypes.length > index + 1) {
          this.listOtpsBed[currentOpt].beds.push(x);
          this.listOtpsBed.push({
            id: this.listOtpsBed.length + 1,
            beds: []
          });
          currentOpt++;
        } else {
          this.listOtpsBed[currentOpt].beds.push(x);
        }
      });
      this.country = this.roomData.countryId;
        this.city = this.roomData.cityId;
        this.district = this.roomData.locId;

      if (roomId != "00000000-0000-0000-0000-000000000000") {
        if (
          this.roomData.channels != null &&
          this.listOfChannels.length == this.roomData.channels.length
        ) {
          this.selectAllChannel = true;
        }

        if (
          this.roomData.markets != null &&
          this.listOfMarkets.length == this.roomData.markets.length
        ) {
          this.selectAllMarket = true;
        }
      }
    },
    getAllRoomCategory() {
      let body = {};
      body.keyword = '';
      body.status = null;
      body.limit = 99999999;
      body.offset = 0;
      body.orderBy = '';
      body.asc = false;
      categoryService
        .getRoomCategoryList(body)
        .then((res) => {
          this.roomCategorys = res.data.map((x) => {
              const i18n = x.i18ns.find(i18n => i18n.lang === this.defaultI18n);  
              return {
                  value: x.id,
                  text: i18n ? i18n.name : x.nameVi
              };
          });
        });
    },
    back() {
      this.$router.push({ name: "roomInfo" });
    },
    clickSelectAllChannel() {
      // this.roomData.channels = [];
      if (this.selectAllChannel) {
        this.listOfChannels.forEach(e => {
          this.roomData.channels.push(e.id);
        });
      } else {
        this.roomData.channels = [];
      }
    },
    clickSelectAllMarket() {
      // this.roomData.markets = [];
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach(e => {
          this.roomData.markets.push(e.id);
        });
      } else {
        this.roomData.markets = [];
      }
    },
    validateAndFocusTab() {
        if (!this.roomData.defaultName) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.roomData.i18ns.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save() {
      await this.validateAndFocusTab();
      await this.$nextTick();
      this.loading = true;
      let form_validate = this.$refs.form.validate();

      // let tempData = {
      //   nameVi: this.roomData.i18ns.find(x => x.lang == "vi").name,
      //   nameEn: this.roomData.i18ns.find(x => x.lang == "en").name,
      //   totalRooms: this.roomData.totalRooms,
      //   defaultPrice: this.roomData.defaultPrice,
      //   weekendRate: this.roomData.weekendRate,
      //   roomSize: this.roomData.roomSize
      // };

      if (
        !form_validate ||
        this.isInvalidRoomParent ||
        this.isDuplicateRoomCode
      ) {
        this.loading = false;
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });

        return false;
      }

      if (!this.checkValidate()) {
        this.loading = false;
        return false;
      }

      let updatedData = {
        id: this.roomData.roomId,
        defaultPrice: this.roomData.defaultPrice,
        weekendPrice: this.roomData.weekendRate,
        maxChildren: this.roomData.maxChildren,
        maxAdults: this.roomData.maxAdults,
        totalRoom: this.roomData.totalRooms,
        numberOfExtraBeds: this.roomData.numberOfExtraBeds,
        roomSize: this.roomData.roomSize,
        i18ns: this.roomData.i18ns,
        operationBedTypes: [],
        viewIds: this.roomData.viewIds,
        sellAllotment: this.roomData.sellAllotment,
        channels: this.applyAllChannel == "ALL" ? null : this.roomData.channels,
        markets: this.applyAllMarket == "ALL" ? null : this.roomData.markets,
        parentId: this.roomData.parentId,
        roomGroup: this.roomData.roomGroup,
        maxGuest: this.roomData.maxGuest,
        maxBaby: this.roomData.maxBaby,
        roomCode: this.roomData.roomCode,
        defaultName: this.roomData.defaultName,
        defaultDesc: this.roomData.defaultDesc,
        status: this.roomData.status ? 1 : 0,
        roomCategoryId: this.roomData.roomCategoryId,
        countryId: this.roomData.countryId,
        cityId: this.roomData.cityId,
        locId: this.roomData.locId,
        lat: +this.roomData.lat,
        lng: +this.roomData.lng,
        priceMin: this.roomData.priceMin,
        priceMax: this.roomData.priceMax
      };
      this.listOtpsBed.forEach(e => {
        e.beds.forEach((item, index) => {
          if (index === e.beds.length - 1) {
            item.operation = 2;
          } else {
            item.operation = 1;
          }
        });
      });
      this.listOtpsBed
        .filter(x => x.beds.length)
        .map(x => x.beds)
        .forEach(x => {
          updatedData.operationBedTypes = updatedData.operationBedTypes.concat(
            x
          );
        });
      if (updatedData.viewIds.length == 0) updatedData.viewIds = [];
      if (!updatedData.id) {
        delete updatedData.id;
        updatedData.roomCode = updatedData.roomCode.toUpperCase();
        service.createRoom(updatedData).then(async res => {
          if (res.responseCode == 0) {
            var newRoomId = res.data.id;
            this.$router.push({
              name: "roomAmenities",
              params: { id: newRoomId }
            });
          } else {
            if (
                res.data == "ENABLE_SYNC_NOT_UPDATED" ||
                res.data == "ENABLE_SYNC_NOT_CREATED"
            ) {
              this.$refs.showDialogModal.toggleDialog(this.$t(res.data));
            } else {
              _alert(res, this.$t(res.data), false);
            } 
          }
          this.loading = false;
        });
        return true;
      }
      service.updateRoom(updatedData).then(res => {
        if (
            res.data == "ENABLE_SYNC_NOT_UPDATED" ||
            res.data == "ENABLE_SYNC_NOT_CREATED"
        ) {
          this.$refs.showDialogModal.toggleDialog(this.$t(res.data));
        } else {
          _alert(res, this.$t(res.data));
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    addBedOption() {
      this.listOtpsBed.push({
        id: this.listOtpsBed.length + 1,
        beds: [
          {
            operation: 2,
            quantity: 1,
            typeId: this.select.bedTypes[0].id
          }
        ]
      });
    },
    removeBedOption(i) {
      this.roomData.operationBedTypes.splice(i, 1);
    },
    addBedType(optionId) {
      let listOfExistedBed = this.listOtpsBed
        .find(x => x.id == optionId)
        .beds.map(x => x.typeId);
      let listIdAvailable = this.select.bedTypes
        .map(x => x.id)
        .filter(x => !listOfExistedBed.includes(x));

      if (listIdAvailable.length <= 0) {
        return;
      }

      let bed = {
        operation: 1,
        quantity: 1,
        typeId: listIdAvailable[0]
      };

      this.roomData.operationBedTypes.push(bed);
      this.listOtpsBed[optionId - 1].beds.push(bed);
    },
    getOptionLabel(listOfBeds) {
      let data = listOfBeds.map(x => {
        let typeId = x.typeId;
        let quantity = x.quantity;
        return `${quantity} ${this.select.bedTypes.find(y => y.id == typeId).value
          }`;
      });
      let label = "";
      data.forEach((x, i) => {
        let symbol =
          i == data.length - 1
            ? ""
            : (i == data.length - 2 ? " " + this.$t("AND") : ",") + " ";
        label += x + symbol;
      });
      return label;
    },
    filterListOfBeds(optionId, typeId) {
      let listOfExistedBed = this.listOtpsBed
        .find(x => x.id == optionId)
        .beds.map(x => x.typeId)
        .filter(x => x != typeId);
      return this.select.bedTypes.filter(x => !listOfExistedBed.includes(x.id));
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.roomData.i18ns.length; i++) {
          this.roomData.i18ns[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.roomData.i18ns.length; i++) {
        this.roomData.i18ns[i].description = value;
      }
    },
    validateRoomCode(roomCode) {
      let body = {
        keyword: roomCode
      };
      service.validateRoomCode(body).then(async res => {
        if (res.responseCode == 0) {
          if (res.data) {
            this.isDuplicateRoomCode = true;
          } else {
            this.isDuplicateRoomCode = false;
          }
        }
      });
    },
    validateRoomParent(roomParentId) {
      let body = {
        id: this.$route.params.id,
        childId: roomParentId
      };
      service.validateRoomParent(body).then(async res => {
        if (res.responseCode == 0) {
          if (res.data) {
            this.isInvalidRoomParent = true;
          } else {
            this.isInvalidRoomParent = false;
          }
        }
      });
    },

    applyAllMarketStatus() {
      if (this.applyAllMarket === "NOT_ALL") {
        this.roomData.markets = null;
        this.selectAllMarket = false;
      } else {
        this.roomData.markets = [];
      }
    },
    applyAllChannelStatus() {
      if (this.applyAllChannel === "NOT_ALL") {
        this.roomData.channels = null;
        this.selectAllChannel = false;
      } else {
        this.roomData.channels = [];
      }
    }
  }
};
</script>
